import styled, { css } from 'styled-components';
import { getRadius } from '../../../foundation/theme/shape.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const ButtonGroupRoot = styled.div `
  ${({ orientation, theme }) => {
    return css `
      // Display & Box Model.
      display: flex;
      flex-direction: ${orientation === 'vertical' ? 'column' : 'row'};
      overflow: hidden;
      width: fit-content;

      > button,
      > * button {
        border-radius: 0;

        ${orientation === 'horizontal' &&
        `
          border-right-width: 0;

          &:focus,
          &:hover {
            border-right-width: 0;
          }
        `}

        ${orientation === 'vertical' &&
        `
          border-bottom-width: 0;

          &:focus,
          &:hover {
            border-bottom-width: 0;
          }
        `}
      }

      > button:first-child,
      > *:first-child button {
        border-top-left-radius: ${getRadius(theme, 'm')};

        ${orientation === 'horizontal' &&
        `
          border-bottom-left-radius: ${getRadius(theme, 'm')};
        `};

        ${orientation === 'vertical' &&
        `border-top-right-radius: ${getRadius(theme, 'm')};`};
      }

      > button:last-child,
      > *:last-child button {
        ${orientation === 'horizontal' &&
        `
          border-right-width: 2px;
          border-top-right-radius: ${getRadius(theme, 'm')};
          border-bottom-right-radius: ${getRadius(theme, 'm')};
        `};

        ${orientation === 'vertical' &&
        `
          border-bottom-width: 2px;
          border-bottom-right-radius: ${getRadius(theme, 'm')};
          border-bottom-left-radius: ${getRadius(theme, 'm')};
        `};
      }
    `;
}}
`;
//# sourceMappingURL=ButtonGroup.styled.js.map